import { getFirestore, doc, collection, query, where, setDoc, addDoc, deleteDoc, onSnapshot, orderBy, getDocs, limit } from "firebase/firestore";
import { getStorage, ref, uploadBytes  } from 'firebase/storage';
const db = getFirestore();
const storage = getStorage();

const bookingModule = {
  state: () => ({
    loading: false,
    bookingId: null,
    bookingError: null,
    bookings: [],
    disposals: [],
    driverBookings: [],
    driverAvailableBookings: [],
    clientTableData:[], 
    trackBookings: [],
    driverBookingError: null,
    text: [],
    clientBookingsQuery: null,
    clientBookingsPageEnd: false
  }),
  getters: {
    getLoading: (state) => state.loading,
    getBookingId: (state) => state.bookingId,
    getBookingError: (state) => state.bookingError,
    getDriverBookings: (state) => state.bookings,
    getText: (state) => state.text,
    getAllBookings: (state) => state.bookings,
    getBookings: (state) => state.bookings.filter((booking) => booking.status.status != 'DISPOSING' && booking.status.status != 'DISPOSED' && !booking.status.origin),
    getQuoteBookings: (state) => state.bookings.filter((booking) => booking.status.status == 'QUOTE'),
    getTrackBookings: (state) => state.trackBookings.filter((booking) => booking.status.status == 'SCHEDULING' || booking.status.status == 'SCHEDULED'),
    getClientTableData: (state) => state.clientTableData.filter((booking) => booking.status != 'DISPOSING' && booking.status != 'DISPOSED' && !booking.origin),
    getAvailableBookings: (state) => state.driverAvailableBookings.filter((booking) => !booking.driver),
    getDeliveryBookings: (state) => state.driverBookings.filter((booking) => booking.status.type === 'DELIVERY' && !booking.status.origin),
    getExchangeBookings: (state) => state.driverBookings.filter((booking) => booking.status.type === 'EXCHANGE' && booking.status.status != 'DISPOSING' && booking.status.status != 'DISPOSED' ),
    getCollectBookings: (state) => state.driverBookings.filter((booking) => booking.status.type === 'COLLECTION' && booking.vehicle?.type.toLowerCase() != 'truck' && booking.status.status != 'DISPOSING' && booking.status.status != 'DISPOSED'),
    getDisposingBookings: (state) => state.driverBookings.filter((booking) => booking.status.status == 'DISPOSING'),
    getTruckBookings: (state) => state.driverBookings.filter((booking) => booking.vehicle?.type.toLowerCase() === 'truck' && booking.status.status != 'DISPOSING' && booking.status.status != 'DISPOSED'),
    getClientDisposals: (state) => state.disposals,
    getDriverBookingError: (state) => state.driverBookingError,
    getClientBookingsQuery: (state) => state.clientBookingsQuery,
    getClientBookingsPageEnd: (state) => state.clientBookingsPageEnd
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setBookingId(state, id) {
      state.bookingId = id;
    },
    setBookingError(state, error) {
      state.bookingError = error;
    },
    addBookings(state, bookings) {
      state.bookings = bookings;
    },
    addDriverBookings(state, bookings){
      state.driverBookings = bookings;
    },
    addDriverAvailableBookings(state, bookings){
      state.driverAvailableBookings = bookings;
    },
    setText(state, text){
      state.text = text;
    },
    deleteBooking(state, bookingId) {
      state.bookings = state.bookings.filter((b) => b.id !== bookingId);
    },
    setBookings(state, bookings) {
      state.bookings = bookings;
    },
    setTrackBookings(state, trackBookings){
      state.trackBookings = trackBookings;
    },
    setClientTable(state, bookings){
      state.clientTableData = bookings;
    },
    setDisposals(state, bookings) {
      state.disposals = bookings;
    },
    updateBooking(state, booking) {
      state.bookings = state.bookings.map((b) => {
        if (b.id === booking.id)
          return booking;
        else return b;
      });
    },
    setClientBookingsQuery(state, query){
      state.clientBookingsQuery = query;
    },
    setClientBookingsPageEnd(state, page){
      state.clientBookingsPageEnd = page;
    }
  },
  actions: {
    async createBooking(context, booking) {
      context.commit('setLoading', true);
      addDoc(collection(db, 'bookings'), booking)
      .then((docRef) => {
        context.commit('setBookingId', docRef.id);
        context.commit('setLoading', false);
      })
      .catch((error) => {
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
        alert(error);
      });
    },
    async updateBooking(context, booking) {
      context.commit('setLoading', true);
      const docRef = doc(db, 'bookings', booking.id);
      await setDoc(docRef, booking, { merge: true })
      .then(() => {
        context.commit('updateBooking', booking);
        if(booking.serviceNote || booking.driver || booking.receiptNumber){
          context.commit('updateBooking', booking);
          window.location.reload(); 
          context.commit('setLoading', false);
        }
        context.commit('setLoading', false);
      })
      .catch((error) => {
        console.log(error);
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
      })
    },
    async updateDriverLocation(context, booking) {
      const docRef = doc(db, 'bookings', booking.id);
      await setDoc(docRef, booking, { merge: true })
      .then(() => {
        context.commit('updateBooking', booking); 
      })
      .catch((error) => {
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
        alert(error);
      });
    },
    async deleteBooking(context, bookingId) {
      context.commit('setLoading', true);
      await deleteDoc(doc(db, 'bookings', bookingId))
      .then(() => {
        context.commit('deleteBooking', bookingId);
        context.commit('setLoading', false);
      })
      .catch((error) => {
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
        alert(error);
      });
    },
    fetchDriverAvailableBookings(context, driverId) {
      onSnapshot(collection(db, 'bookings'), () => {
        const bookings = [];
        const q = query(collection(db, 'bookings'), where('drivers', 'array-contains', driverId), where('status.status', '==','SCHEDULING'), orderBy('timeStamp', 'asc'));
        getDocs(q)
        .then((doc) => {
          doc.docChanges().forEach((booking) =>{
            if(booking.doc.data().arrival != ''){
              context.commit('setLoading', false);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
            else{
              context.commit('setLoading', true);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
          })
          context.commit('addDriverAvailableBookings', bookings);
          context.commit('setLoading', false);
        })
        .catch((err) => console.log(err))
      })
    },
    fetchDriverBookings(context, driverId) {
      onSnapshot(collection(db, 'bookings'), () => {
        const bookings = [];
        const q = query(collection(db, 'bookings'), where('driver.id', '==', driverId), orderBy('timeStamp', 'desc'));
        getDocs(q)
        .then((doc) => {
          doc.docChanges().forEach((booking) =>{
            if(booking.doc.data().arrival != ''){
              context.commit('setLoading', false);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
            else{
              context.commit('setLoading', true);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
          })
          context.commit('addDriverBookings', bookings);
          context.commit('setLoading', false);
        })
      })
    },
    async fetchClientBookings(context, userId) {
      onSnapshot(collection(db, 'bookings'), async () => {
        const bookings = [];
        let bookingData = [];
        let texts = [];

        const q = query(collection(db, 'bookings'), where('userId', '==',  userId), orderBy('timeStamp', 'desc'));
        await getDocs(q)
        .then( async (doc) => {
          doc.docChanges().forEach((booking) =>{
            if(booking.doc.data().arrival != ''){
              context.commit('setLoading', false);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
            else{
              context.commit('setLoading', true);
              bookings.push({ ...booking.doc.data(), id: booking.doc.id });
            }
            
          })
          bookings.forEach((booking)=>{
            let text = '';
            if (booking.status.status == 'SCHEDULING' && !booking.status.origin){
              text = `Booking ${booking.orderNumber.number} - Finding driver...`;
              texts.push(text);
            }
            if (booking.status.status == 'SCHEDULED' && !booking.status.origin){
              text = `Booking ${booking.orderNumber.number} - Scheduled by ${booking.driver.name}`;
              texts.push(text);
            }
            if (booking.status.status == 'DROPPED' && !booking.status.origin){
              text = `Booking ${booking.orderNumber.number} has been dropped by ${booking.driver.name}`;
              texts.push(text);
            }

            //let cost = parseInt(booking.cost.value);
            //let promo = cost - (cost *0.1);

            bookingData.push({
              origin: booking.status.origin,
              order: booking.orderNumber.number,
              date: booking.preferredDate,
              address: booking.capturedAddress.split(', South Africa').join(' '),
              wasteName: booking.waste.name,
              vehicleName: booking.vehicle.name,
              driverName: booking.driver? booking.driver.name : 'Processing...', 
              type: booking.status.type,
              status: booking.status.status,
              cost: booking.status.type == 'COLLECTION' && booking.vehicle.name.includes('Skip') ? 0 : booking.cost.value
            });
          })
          await context.commit('setText', texts);
          await context.commit('setBookings', bookings);
          await context.commit('setClientTable', bookingData);
          context.commit('setLoading', false);
        })
      }) 
    },

    trackBookings(context, userId) {
      onSnapshot(collection(db, 'bookings'), () => {
        const bookings = [];
        const q = query(collection(db, 'bookings'), where('userId', '==',  userId), where('status.status', '!=', 'DISPOSING'), orderBy('status.status', 'desc'), orderBy('timeStamp', 'desc'));
        getDocs(q)
        .then((doc) => {
          doc.docChanges().forEach((booking) =>{
            bookings.push({ ...booking.doc.data(), id: booking.doc.id });
          })
          context.commit('setTrackBookings', bookings);
        })
      }) 
    },


    async fetchClientDisposals(context, userId) {
      context.commit('setLoading', true);
      const disposing = getDocs(query(collection(db, 'bookings'), where('userId', '==',  userId), where('status.status', '==', 'DISPOSING'), orderBy('orderNumber.id', 'desc'), limit(100)));
      const disposed = getDocs(query(collection(db, 'disposed-bookings'), where('userId', '==',  userId), where('status.status', '==', 'DISPOSED'), orderBy('orderNumber.id', 'desc'), limit(100)));
      const dropped = getDocs(query(collection(db, 'bookings'), where('userId', '==',  userId), where('status.origin', '==', 'DELIVERY'), orderBy('orderNumber.id', 'desc'), limit(100)));
      let bookings = [];
      Promise.all([disposed, disposing, dropped])
      .then((snapshots) => {
        snapshots.map(snapshot => {  
          snapshot.docs.forEach((booking) => {
            let actualDate = booking.timeStamp ? new Date(booking.timeStamp.seconds * 1000) : undefined;
            bookings.push({
              id: booking.data().orderNumber.id,
              order: booking.data().orderNumber.number,
              date: actualDate ? actualDate.getDate() + "/" + (actualDate.getMonth() + 1) + "/" + actualDate.getFullYear() : booking.data().preferredDate,
              address: booking.data().capturedAddress.split(', South Africa').join(' '),
              wasteName: booking.data().waste.name,
              vehicleName: booking.data().vehicle.name,
              driverName: booking.data().driver.name,
              type: booking.data().status.type, 
              status: booking.data().status.status,
              cost: booking.data().status.type == 'COLLECTION' && booking.data().vehicle.name.includes('Skip') ? 0 : booking.data().cost.value
            });
          });
        })
        context.commit('setDisposals', bookings);
        context.commit('setLoading', false);
      })
      .catch((error) => {
        console.log(error);
        context.commit('setBookingError', error);
        context.commit('setLoading', false);
      });
    },
    async uploadImage(context, receiptNumber, imageData){
      context.commit('setLoading', true);
      const storageRef =  ref(storage, `${'disposed waste/receipt number: ' + receiptNumber}`);
      await uploadBytes(storageRef, imageData)
      .then(()=> {
        context.commit('setLoading', false);
      })
      .catch((error) => {
        console.log(error);
        context.commit('setLoading', false);
        alert(error);
      });   
    },
    updateUserBooking(context, user){
      context.commit('setLoading', true);
      getDocs(query(collection(db, 'bookings'), where('userId', '==', user.id)))
      .then((snapshot) => {
        snapshot.docs.forEach(async (booking) => {
          let bookingId = booking.id;
          if (booking.status.status == 'SCHEDULING' || booking.status.status == 'SCHEDULED'){
            await setDoc(doc(db, 'bookings', bookingId), {
              customer: {
                card: {
                  expiry: user.expiry,
                  holder: user.holder,
                  lastDigits: user.lastDigits,
                  registrationId: user.registrationId
                }
              }
            }, {merge: true})
            .then(() => context.commit('setLoading', false))
            .catch((err) => console.log(err))
          }
        })
      })
      .catch((err) => console.log(err))
    }
  }
}

export default bookingModule;